"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgFlag = function SvgFlag(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M15 15a1 1 0 01.293-.707c.22-.22.614-.483 1.21-.721C17.407 13.21 18.564 13 20 13c1.417 0 2.383.276 4.371 1.072 1.762.704 2.546.928 3.629.928 1.189 0 2.094-.165 2.754-.428.341-.137.508-.249.539-.28.63-.63 1.707-.183 1.707.708v12a1 1 0 01-.293.707c-.22.22-.614.483-1.21.721-.903.362-2.06.572-3.497.572-1.417 0-2.383-.276-4.371-1.072C21.867 27.224 21.083 27 20 27c-1.189 0-2.094.165-2.754.428a4.09 4.09 0 00-.247.108L17 34a1 1 0 01-2 0V15zm5 0c-1.189 0-2.094.165-2.754.428a4.094 4.094 0 00-.246.108v9.86c.82-.253 1.814-.396 3-.396 1.417 0 2.383.276 4.371 1.072 1.762.704 2.546.928 3.629.928 1.189 0 2.094-.165 2.754-.428.095-.039.177-.075.246-.108v-9.86c-.82.253-1.814.396-3 .396-1.417 0-2.383-.276-4.371-1.072C21.867 15.224 21.083 15 20 15z",
    id: "flag_svg__a"
  }));
};

var _default = SvgFlag;
exports["default"] = _default;